import props from "./../../../src-utils/propDefiner";

export default {
  ...props("count", Number, "pm-carousel-item"),
};
